// extracted by mini-css-extract-plugin
module.exports = {"base":"ClanWallet_base_25cLH","header":"ClanWallet_header_2XVrO","value":"ClanWallet_value_2HRiq","tooltip":"ClanWallet_tooltip_3ZqFN","balanceRow":"ClanWallet_balanceRow_rlcYi"};